import PageShell from "../../../layout/PageShell";
import useAccountId, {
  useBreadcrumbsWithCustomDomain,
} from "../../../hooks/customDomainHooks";
import TeamAlignmentReport from "./TeamAlignmentReport";

const TeamAlignmentReportPage = () => {
  const { accountId } = useAccountId();
  const breadcrumbs = useBreadcrumbsWithCustomDomain([
    { type: "HOME", href: `/${accountId}/home` },
    { name: "Reports", href: `/${accountId}/reports` },
    { name: "Team Alignment" },
  ]);

  return (
    <PageShell breadcrumbs={breadcrumbs}>
      <TeamAlignmentReport />
    </PageShell>
  );
};

export default TeamAlignmentReportPage;
